import React  from 'react';

const EmailField = (props) => (
    <div className='contact-block__form-row'>
        <label>{props.Placeholder}:</label>
        <input required={props.Required} type='email' placeholder={props.Placeholder + ':'} name={props.Name} />
    </div>
)

export default EmailField;